(() => {
  const path = window.location.pathname || '';
  if (!path.startsWith('/pages/')) return;
  const handle = path.split('/').filter(Boolean).pop().toLowerCase();
  if (['guide-des-luminaires', 'contact', 'faq-luminaire-france'].includes(handle)) return;

  const apply = () => {
    const nav = document.querySelector('.lf-smart-breadcrumb, .lf-breadcrumb');
    if (!nav) return;
    let parent = [...nav.querySelectorAll('a')].find((link) =>
      link.href.includes('/pages/guide-des-luminaires') || /^guides?$/i.test(link.textContent.trim())
    );
    if (!parent && handle === 'eclairage-led') {
      const current = nav.querySelector('.lf-breadcrumb__current, [aria-current="page"]');
      if (current) {
        parent = document.createElement('a');
        parent.className = 'lf-breadcrumb__item lf-breadcrumb__category';
        parent.href = '/pages/guide-des-luminaires';
        parent.textContent = 'Guides';
        const separator = document.createElement('span');
        separator.className = 'lf-breadcrumb__separator';
        separator.setAttribute('aria-hidden', 'true');
        separator.textContent = '›';
        const existingSeparator = current.previousElementSibling;
        if (existingSeparator && existingSeparator.classList.contains('lf-breadcrumb__separator')) {
          current.before(parent, separator);
        } else {
          const home = nav.querySelector('.lf-breadcrumb__home');
          if (home) {
            const homeSeparator = separator.cloneNode(true);
            home.after(homeSeparator, parent, separator);
          }
        }
      }
    }
    if (!parent) return;
    if (parent.textContent.trim() !== 'Guides') parent.textContent = 'Guides';
    if (parent.getAttribute('href') !== '/pages/guide-des-luminaires') parent.setAttribute('href', '/pages/guide-des-luminaires');
    nav.classList.add('lf-guide-breadcrumb-active');
  };

  const observer = new MutationObserver(apply);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  apply();
  window.setTimeout(() => observer.disconnect(), 10000);
})();


(function(){
 'use strict';
 var scheduled=false;
 function align(){
  var inner=document.querySelector('main#MainContent>nav.lf-breadcrumb>.lf-breadcrumb__inner');
  if(!inner)return;
  var desktop=matchMedia('(min-width:1200px)').matches;
  var target=document.querySelector(desktop?'.lf66-desktop .lf66-links .lf66-entry:first-child .lf67-main-icon':'.lf66-mobile-bar .lf66-mobile-trigger');
  if(!target||!target.getBoundingClientRect().width){inner.style.removeProperty('--lf76-breadcrumb-start');return;}
  var start=target.getBoundingClientRect().left-inner.getBoundingClientRect().left;
  inner.style.setProperty('--lf76-breadcrumb-start',Math.max(8,start).toFixed(1)+'px');
 }
 function schedule(){
  if(scheduled)return;scheduled=true;
  requestAnimationFrame(function(){scheduled=false;align()});
 }
 function boot(){
  schedule();
  addEventListener('resize',schedule,{passive:true});
  addEventListener('orientationchange',schedule,{passive:true});
  addEventListener('load',schedule,{once:true});
  document.addEventListener('shopify:section:load',schedule);
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(schedule);
  if('ResizeObserver' in window){
   var observer=new ResizeObserver(schedule);
   document.querySelectorAll('.lf66-desktop .lf66-inner,.lf66-mobile-bar').forEach(function(menu){observer.observe(menu)});
  }
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();


